<template>
  <div class="p-8 bg-neutral-300">
    <div class="flex flex-col">
      <Lynx-Title :text="`Editar Certificado   ${!empresaId ? '' :'- '+empresaId}`" />
      <form class="flex flex-col">

        <div  class="flex pb-4">
        <b-radio :disabled="certificado" v-model="form.owner_type" native-value="empresa" class="pr-4">
          Pessoa Jurídica
        </b-radio>
        <b-radio :disabled="certificado" v-model="form.owner_type" native-value="cliente">
          Pessoa física
        </b-radio>
      </div>
        <label v-if="certificado" class="flex flex-col pb-2">
        <Lynx-Label
          :label="certificado ? certificado.owner_type : ''"
        />
        <Lynx-Input disabled v-model="owner" />
      </label>

      

    
      <label
        v-show="!certificado"
        class="flex flex-col pb-4"
        v-if="form.owner_type === 'empresa'"
        
      >
        <Lynx-Label label="Empresa" />
        <b-autocomplete
          :data="filteredEmpresas"
          placeholder="Pesquise uma empresa"
          field="empresa"
          :loading="isFetching"
          @input="getAsyncEmpresa"
          @select="(option) => (form.owner_id = option.id)"
        />
      </label>
      <label v-show="!certificado" class="flex flex-col pb-2" v-else>
        <Lynx-Label label="Cliente" />
        <b-autocomplete
          :data="filteredClientes"
          placeholder="Pesquise um Cliente"
          field="cliente"
          :loading="isFetching"
          @input="getAsyncCliente"
          @select="(option) => (form.owner_id = option.id)"
        />
      </label>

        <label class="flex flex-col pb-5">
          <Lynx-Label label="Data de vencimento" />
          <b-datepicker
            :years-range="[-1, 5]"
            v-model="form.validade"
            :day-names="dayNames"
            :month-names="monthNames"
          />
        </label>
        <label  class="flex flex-col pb-2">
        <Lynx-Label
          label="senha"
        />
        <Lynx-Input  v-model="form.senha" />
      </label>
      <label  class="flex flex-col pb-2">
        <Lynx-Label
          label="codigo"
        />
        <Lynx-Input  v-model="form.codigo" />
      </label>
      <label  class="flex flex-col pb-2">
        <Lynx-Label
          label="Emitido"
        />
      <b-switch
            v-model="form.emitido"
          />
          </label>
      <label  class="flex flex-col pb-2">
        <Lynx-Label
          label="Descrição"
        />
        <Lynx-Input  v-model="form.descricao" />
      </label>


        <b-field class="file" required>
          <InputFile
            
            class="px-2"
            text="Certificado Digital"
            ref="arquivoCertificadoDigitalInput"
          />
          <span class="file-name" v-if="form.file">
            {{ form.file.name }}
          </span>
          <span
            class="file-name cursor-pointer"
            v-if="!form.file && arquivo"
            @click="openFile()"
          >
            {{ arquivo.nome }}
            <b-icon icon="attachment"></b-icon>
          </span>
        </b-field>
      </form>
      <!--  TAXAS -->
     
      <Lynx-Button
        type="submit"
        class="self-end"
        text="Enviar"
        icon="Check"
        :loading="loadingButton"
        @click.native="onSubmit"
      />
    </div>
  </div>
</template>

<script>
import {
  storeCertificadoRequest,
  updateCertificadoRequest,
  showCertificadoRequest,
} from "@/services/requests/certificado";
import InputFile from "@/components/helpers/InputFile";

import {
  storeTaxasRequest,
  updateTaxasRequest,
  showTaxasRequest,
} from "@/services/requests/taxas";

import {
  searchEmpresasRequest,
  cancelarFaturaRequest,
} from "@/services/requests/empresas";
import { monthNames, dayNames } from "@/utils/utils";
import moment from "moment";
import base64Files from "../../../mixins/base64Files";
import { mapGetters } from "vuex";
import { formatDateToBr } from '../../../utils/momentHelpers';
import { clientesSearchRequest } from "@/services/requests/clientes";
import debounce from "@/mixins/debounce";

export default {
  name: "Certificado",
  mixins: [base64Files,debounce],
  components:{InputFile},

  props: {
    certificado: {
      required: false,
      type: Object,
    },
    empresaId: {
      required: false,
      type: Number,
    },
  },
  data() {
    return {
      form: {
        owner_id: null,
        owner_type: "empresa",
        senha: null,

        codigo: null,

        validade: new Date(),
      },
      arquivo: null,
      loadingFile: false,
      loadingButton: false,
      monthNames,
      dayNames,
      isFetching:false,
      empresas: [],
      clientes: [],
      // taxas: [

      // ],
     
      errorMessage: "Não foi possivel editar o alvará",
      // taxasOptions: [
      //   {
      //     label: "selecione uma taxa",
      //     value: 0,
      //   },
      //   {
      //     label: "Taxa de Alvará",
      //     value: 1,
      //   },
      //   {
      //     label: "Taxa de fiscalização",
      //     value: 2,
      //   },
      //   {
      //     label: "Taxa de Expediente",
      //     value: 3,
      //   },

      //   {
      //     label: "Taxa Mobiliaria ",
      //     value: 4,
      //   },
      // ],
    };
  },
  computed: {
    ...mapGetters(["getToken"]),
    filteredEmpresas() {
      return this.empresas.map((item) => {
        return {
          id: item.id,
          empresa: `${item.id} - ${item.razao_social}`,
        };
      });
    },
    filteredClientes() {
      return this.clientes.map((item) => {
        return {
          id: item.id,
          cliente: `${item.id} - ${item.nome_completo}`,
        };
      });
    },
  },
  methods: {
    fetchFile() {
      this.loadingFile = true;
      if(this.certificado != null){

      //   this.taxas= [
      //   {
      //     type_document: "sanitario",
      //     document_id: this.certificado.id,
      //     empresa_id: this.empresaId,
      //     tipo_taxa: 0,
      //     validade: new Date(),
      //   },
      // ],
    // showTaxasRequest(this.certificado.id)
    //     .then((response) => {
        
   
    //     this.taxas = response.data.data

        
    //   this.taxas.forEach(element => {
    //     element.validade = new Date(moment(element.validade))
    //   });

    
      
        
       
        // })
        // .finally(() => (this.loadingFile = false));
      

      showCertificadoRequest(this.certificado.id)
        .then((response) => {
          // console.log(response.data.data.arquivo)
          this.owner = response.data.data.owner_id + ' - '+ response.data.data.nome 
          this.arquivo = response.data.data.arquivo;
        })
        .finally(() => (this.loadingFile = false));
      }
    },
    async onSubmit() {
      // this.loadingButton = true;

      // if (this.arquivo == null) {
        let  arq 
      if (this.$refs.arquivoCertificadoDigitalInput) {
        arq = await this.$refs.arquivoCertificadoDigitalInput.submit()
      }


      const form = {
        ...this.form,
        arquivo_id: arq,
        validade: moment(this.form.validade).format("YYYY-MM-DD"),
      };

      
      
//  console.log(this.certificado)
      if (this.certificado == null) {
 console.log('entrou')
     

        storeCertificadoRequest(form)
          .then(() => {
            this.$emit("edit-certificado");
            this.$snack.success("Certificado criado com sucesso");
          })
          .catch((err) =>
            this.$snack.error(err.response.data.message || this.errorMessage)
          )
          .finally(() => (this.loadingButton = false));

      } else {
        updateCertificadoRequest(this.certificado.id, form)
          .then(() => {
            this.$emit("edit-certificado");
            this.$snack.success("Certificado atualizado com sucesso");
            
          })
          .catch((err) =>
            this.$snack.error(err.response.data.message || this.errorMessage)
          )
          .finally(() => (this.loadingButton = false));
        


      }
//  }

         for (let index = 0; index < this.taxas.length; index++) {
   
        this.taxas[index].file= await this.convertFileToBase64(this.taxas[index].file),
        this.taxas[index].validade= moment(this.taxas[index].validade).format("YYYY-MM-DD")
    
    }
      // console.log(this.taxas)

  //     if (this.taxas[0]) {

  //            storeTaxasRequest(this.taxas)
  //         .then((response) => {
  //         // console.log(response)
  //           this.$snack.success("Taxa criada com sucesso");
  //       //  for (let index = 0; index < this.taxas.length; index++) {
       
  //       //  }
  //         })
  //         .catch((err) =>
  //           this.$snack.error(err.response.data.message || this.errorMessage)
  //         )
  //                 .finally(() => (this.loadingButton = false));
  // }
    },
    openFile() {
      window.open(
        `${process.env.VUE_APP_API_URL}/arquivos/${this.arquivo.id}/open?token=${this.getToken}`
      );
    },
    getAsyncEmpresa(name) {
      if (!name) return;
      let self = this;
      this.debounce(function () {
        self.isFetching = true;
        searchEmpresasRequest(name)
          .then((response) => {
            self.empresas = response.data.data;
          })
          .catch((error) => self.$snack.error(error.response.data.message))
          .finally(() => (self.isFetching = false));
      }, 600);
    },
    getAsyncCliente(name) {
      if (!name) return;
      let self = this;
      this.debounce(function () {
        self.isFetching = true;
        clientesSearchRequest(name)
          .then((response) => {
            self.clientes = response.data.data;
          })
          .catch((error) => self.$snack.error(error.response.data.message))
          .finally(() => (self.isFetching = false));
      }, 600);
    },
    // addTaxa() {
    //   this.taxas.push({
    //     type_document: "sanitario",
    //     document_id: this.certificado.id,
    //     empresa_id: this.empresaId,
    //     tipo_taxa: 0,
    //     validade: new Date(),
    //     file: null,
    //   });
    // },
  },
  beforeMount() {
   
       if(this.certificado != null){
        (this.owner = `${this.certificado.owner_id} - ${this.certificado.nome}`),
          (this.form.owner_id = this.empresaId);
    this.form = {
      owner_id: this.empresaId,
      id: this.certificado.id,

      owner_type: this.certificado.owner_type ,
      codigo: this.certificado.codigo ,
      descricao: this.certificado.descricao ,
      emitido: this.certificado.emitido == 1 ,

      senha: this.certificado.senha ,
      validade: this.certificado.validade ? (new Date(moment(this.certificado.validade)) ) :new Date(moment()) ,

    };
       }else{
            this.form= {
      owner_type: "empresa",
      codigo: null,
      senha: null,
      descricao: null ,
      imitido: false ,

        owner_id: null,
        validade: new Date(),
      }
       }
    // if (this.form.validade < new Date())
    //   this.form.validade = null;
  },
  mounted() {

    this.fetchFile();
  },


};
</script>

<style scoped>
.v-line {
  height: 0.1vw;
  width: 100%;
  border-width: 0;
  color: rgb(63, 62, 62);
  background-color: rgb(35, 34, 34);
}
</style>
